/**
 * QUAL CAPACIDADE CADA ROTA EXIGE (CERES-018A).
 *
 * O menu já escondia o que a organização não contratou. Esconder o link, porém,
 * nunca impediu ninguém de digitar o endereço — e quem digitava via a tela
 * montar, as consultas tomarem 403 e um erro genérico aparecer, o que parece
 * defeito do sistema em vez de recurso fora do plano.
 *
 * O mapa NÃO é escrito de novo aqui: ele é derivado da mesma lista de navegação
 * que desenha o menu. Dois mapas para a mesma pergunta divergem no primeiro
 * recurso novo, e quem paga é o usuário que vê o link e não pode entrar (ou o
 * contrário).
 *
 * Isto é EXPERIÊNCIA, não autorização: o servidor recusa de qualquer forma,
 * venha o pedido de um clique ou de uma URL.
 */

import { ITENS_DE_NAVEGACAO } from '../components/navegacao';

interface RotaComCapacidade {
  /** Caminho declarado na navegação, sem barra final. */
  caminho: string;
  capacidade: string;
}

/** Derivado uma vez: a navegação é estática. */
const ROTAS: RotaComCapacidade[] = ITENS_DE_NAVEGACAO
  .filter((item): item is typeof item & { feature: string } => typeof item.feature === 'string')
  // A raiz ("/") é o ponto de partida e não é um domínio contratável: barrar
  // alguém no painel inicial deixaria a pessoa sem lugar nenhum para ir.
  .filter((item) => item.to !== '/')
  .map((item) => ({ caminho: item.to.replace(/\/+$/, ''), capacidade: item.feature }));

/**
 * A capacidade exigida por um caminho, ou `null` quando a rota não é
 * controlada por plano.
 *
 * Casa por PREFIXO de segmento, para que `/empresas/123` herde a exigência de
 * `/empresas` — a ficha de uma empresa é a mesma capacidade da lista. O
 * casamento é por segmento inteiro de propósito: `/empresas` não pode capturar
 * `/empresas-parceiras`, que seria outro recurso.
 */
export function capacidadeDaRota(caminho: string): string | null {
  const limpo = caminho.replace(/\/+$/, '') || '/';
  let melhor: RotaComCapacidade | null = null;
  for (const rota of ROTAS) {
    if (limpo === rota.caminho || limpo.startsWith(`${rota.caminho}/`)) {
      // Mais específica vence: `/playbook/secao` antes de `/playbook`.
      if (melhor === null || rota.caminho.length > melhor.caminho.length) melhor = rota;
    }
  }
  return melhor?.capacidade ?? null;
}
